import { Button, Col, Input, Modal, ModalBody, Row } from "reactstrap"
import { IoMdArrowBack } from "react-icons/io"
import logo from "../../../../../assets/images/logo/logo.svg"
import styles from "./CustomerServiceModal.module.scss"
import { CiViewList } from "react-icons/ci"
import { TbTruckDelivery } from "react-icons/tb"
import { MdAssignmentReturned } from "react-icons/md"
import { GoCreditCard } from "react-icons/go"
import { GrAnnounce } from "react-icons/gr"
import { RiUserSettingsLine } from "react-icons/ri"
import classNames from "classnames"
import { BsChevronRight } from "react-icons/bs"
import { FiSend } from "react-icons/fi"
import { ImAttachment } from "react-icons/im"

const CustomerServiceModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  const FAQCategories = [
    { icon: CiViewList, label: "Order query" },
    { icon: MdAssignmentReturned, label: "Return & Refund" },
    { icon: TbTruckDelivery, label: "Track" },
    { icon: RiUserSettingsLine, label: "Account Manage" },
    { icon: GoCreditCard, label: "Payment" },
    { icon: GrAnnounce, label: "Promo" },
  ]

  const questions = ["Can i cancel my order?", "What if a product is out of stock?", "Can i cancel my order?", "Can i pay in one-click?"]

  return (
    <div>
      <Modal isOpen={isModalOpen} toggle={toggle} centered size="xl" scrollable>
        <ModalBody className="p-0">
          <div className={styles.header}>
            <Row noGutters>
              <Col xs="1" className="d-flex align-items-center text-white">
                <IoMdArrowBack size={24} onClick={toggle} className="cursor-pointer" />
              </Col>
              <Col className="text-center">
                <img src={logo} alt="" />
              </Col>
              <Col xs="1"></Col>
            </Row>
          </div>

          <Row noGutters className="my-3 mx-3 mx-md-5 shadow overflow-x-auto flex-nowrap">
            {FAQCategories.map((item, index) => (
              <Col className={`text-center ${styles.tab}`} key={index}>
                <div className="p-2">
                  <div>
                    <item.icon size={24} />
                  </div>
                  <div className={`text-nowrap ${styles['category-label']}`}>{item.label}</div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="m-3">
            <div className={`shadow p-3 ${styles.receiver}`}>
              <div className="fw-medium fs-md-4 mb-2">Top Questions</div>
              <div className={styles.questions}>
                {questions?.length > 0 ? (
                  questions?.map((item, index) => (
                    <div key={index} className={classNames("p-3", styles.listItems)}>
                      <div>{item}</div>
                      <div>
                        <BsChevronRight />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-3">No Questions</div>
                )}
              </div>
            </div>

            <div className={`${styles.sender}`}>
              <div>How to provide feedback?</div>
            </div>

            <div className={`shadow p-3 mt-3 ${styles.receiver}`}>
              <div>
                It sound like you want to ask about “How do I leave a review?” Simply click the options below [yes] or [No] to continue.
              </div>
              <div className="d-flex gap-2 mt-3">
                <button className={styles.button}>Yes</button>
                <button className={styles.button}>No</button>
              </div>
            </div>

            <div className={`d-flex gap-2 text-nowrap ${styles["pills-wrapper"]}`}>
              <div className={styles.pill}>Order query</div>
              <div className={styles.pill}>Urgent delivery</div>
              <div className={styles.pill}>Feedback</div>
              <div className={styles.pill}>Rating</div>
            </div>

            <div className={`${styles["input-wrapper"]} mt-3`}>
              <div>
                <Input placeholder="Type your message here" className={styles.input} />
              </div>
              <div className={styles.icons}>
                <button><ImAttachment size={24} /></button>
                <button><FiSend size={24} /></button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default CustomerServiceModal
